<div
  class="flex flex-col"
  [ngClass]="{
    'rounded-radius-primary bg-background-fixed pt-6 pr-6 pb-4 pl-6 drop-shadow-foreground-primary-100-shadow-30 dark:drop-shadow-foreground-secondary-100-shadow-30 max-h-[591px]':
      !vm().embedded,
  }"
>
  <div class="flex flex-col">
    <div class="flex flex-col items-center">
      <svg-icon key="warning-16" size="48" class="text-status-warning"></svg-icon>
    </div>

    <div class="flex flex-col gap-4 mt-8">
      <div class="text-2xl font-semibold text-center">
        {{ vm().title$ | async }}
      </div>

      <div class="text-sm text-center">
        {{ vm().message$ | async }}
      </div>
    </div>

    <div class="flex justify-center gap-4 mt-10">
      <app-button class="flex-1" type="secondary" (clickEvent)="onCancelClick()">
        {{ vm().cancelButtonLabel$ ?? defaultCancelButtonLabel$ | async }}
      </app-button>

      <app-button class="flex-1" type="primary" (clickEvent)="onConfirmClick()">
        {{ vm().confirmButtonLabel$ ?? defaultConfirmButtonLabel$ | async }}
      </app-button>
    </div>
  </div>

  @if (!vm().embedded) {
    <button (click)="onCancelClick()" type="button" class="flex items-center justify-center absolute top-6 right-6">
      <svg-icon key="close-40" size="40"></svg-icon>
    </button>
  }
</div>
